<template>
<div id="about-page">
  <v-container fluid grid-list-xl>
    <v-layout row wrap justify-center>
      <v-flex xs12 offset-md3 offset-lg2>
        <span class="display-1">Image Gallery</span> <v-btn v-if="!showAboutForm" style="margin-bottom: 18px;" class="primary" @click="showAddForm" round icon><v-icon>add</v-icon></v-btn>
      </v-flex>
      <v-flex v-if="projectData.length > 0 && !showAboutForm" xs12 offset-md3 offset-lg2>
        <v-tabs color="grey lighten-2" left>
          <v-tab v-for="(item, i) in projectData" :key="i" @click="activeProject = i">
            {{ item.name }}
          </v-tab>
        </v-tabs>
        <v-layout row wrap v-if="projectDetailsData.length > 0">
          <v-flex xs12 md4 lg3>
            <v-card>
              <v-list class="grey lighten-3"> 
                <v-list-tile v-for="(item, itemIndex) in projectDetailsData" :key="itemIndex" @click="showDetailsTab(itemIndex, item.id)">
                  <v-list-tile-action>
                    <v-icon v-if="paraIndex === itemIndex">star</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title v-text="item.headline" style="text-transform: uppercase;font-size: 10pt;font-weight: bold;color:#676767;margin-left: -20px;"></v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-flex>
          <v-flex xs12 md8>
            <v-layout row wrap>
              <v-flex x2 v-if="aboutData.length > 0" v-for="(image, imgIndex) in getImagePerPage" :key="imgIndex" >
                <v-card color="grey lighten-2">
                  <v-container style="position:relative;">
                    <img style="width:200px;height:200px;" :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + image.name"/>
                    <p class="caption">Modified on: {{ image.modified_on | dateTimeFormat }}</p>
                    <p class="caption">Modified by: {{ image.author.email }}</p>
                    <v-btn @click="deleteItem(image, imgIndex)" round dark><v-icon>highlight_off</v-icon>Remove</v-btn>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
            <v-container v-if="aboutData.length === 0">
              <v-layout row wrap justify-center>
                <v-flex>
                  <v-card>
                    <v-card-title>
                    No Images
                    </v-card-title>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container>
              <v-layout row wrap justify-center>
                <v-pagination :length="Math.ceil(aboutData.length/imagesPerPage)" v-model="page" circle></v-pagination>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="showAboutForm" xs12 offset-md3 offset-lg2>
        <v-card color="grey lighten-2">
          <v-container>
            <MultipleImageInputForm
              @addItem="addItem"
              @goBack="showAboutForm = !showAboutForm"
              :buttonName="buttonName"
            />
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
// import axios from 'axios'
import Api from '@/api'
import { mapGetters } from 'vuex'
import MultipleImageInputForm from '@/components/MultipleImageInputForm'

export default {
  data () {
    return {
      aboutData: [],
      showAboutForm: false,
      buttonName: 'Add',
      projectData: [],
      projectDetails: [],
      activeProject: 0,
      paraIndex: 0,
      page: 1,
      imagesPerPage: 9,
      activeProjectID: '',
      activeDetailsID: ''
    }
  },
  components: {
    MultipleImageInputForm
  },
  beforeMount () {
    if (!this.loginStatus) {
      this.$router.push('/admin/login')
    } else {
      this.getProjectData()
    }
  },
  watch: {
    activeProject: function () {
      this.aboutData = []
      this.paraIndex = 0
      this.page = 1
      this.activeProjectID = ''
      this.activeDetailsID = ''
    }
  },
  computed: {
    ...mapGetters({
      loginStatus: 'adminUser/getLoginStatus',
      currentUser: 'adminUser/getLoggedInUser',
      authUsername: 'adminUser/getAuthUser',
      authPassword: 'adminUser/getAuthPassword'
    }),
    projectDetailsData: function () {
      return this.getProjectDetails()
    },
    getImagePerPage: function () {
      return this.aboutData.slice(((this.page - 1) * this.imagesPerPage), (this.imagesPerPage * this.page))
    }
  },
  methods: {
    getProjectDetails () {
      const details = []
      if (this.projectDetails.length > 0) {
        this.projectDetails.forEach((el) => {
          if (el.project.id === this.projectData[this.activeProject].id) {
            details.push(el)
          }
        })
      }
      return details
    },
    getProjectData () {
      const path = '/project'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.projectData = response.data.project
            this.projectDetails = response.data.project_details
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    getAboutData (projectID, projectDetailsID) {
      const path = '/image-gallery/' + projectID + '/' + projectDetailsID
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            // console.log(response.data.about)
            // console.log(response.data)
            this.aboutData = response.data.imagegallery
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    showDetailsTab (itemIndex, detailsID) {
      this.page = 1
      this.activeDetailsID = detailsID
      this.paraIndex = itemIndex
      this.activeProjectID = this.projectData[this.activeProject].id
      this.getAboutData(this.activeProjectID, detailsID)
    },
    showAddForm () {
      this.showAboutForm = !this.showAboutForm
      this.buttonName = 'Add'
    },
    addItem (data, imageFile) {
      const path = '/image-gallery'
      const auth = {username: this.authUsername, password: this.authPassword}
      let formData = new FormData()
      let imageFileArr = []
      for (let i = 0; i < imageFile.files.length; i++) {
        imageFileArr.push(imageFile.files[i])
      }
      [].forEach.call(imageFile.files, (file, index) => {
        formData.append('image' + index, file)
      })
      formData.append('data', JSON.stringify(data))
      this.$nextTick(() => {
        this.$swal({
          title: 'Adding Item',
          onOpen: () => {
            this.$swal.showLoading()
            Api.post(path, formData, auth, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
              .then(response => {
                if (response.data.status === 0) {
                  this.$swal(response.data.message)
                  this.showAboutForm = !this.showAboutForm
                  this.getAboutData()
                } else {
                  this.$swal(response.data.message)
                }
              })
              .catch(error => {
                this.$swal(error.toString().substring(0, 100))
              })
          },
          allowOutsideClick: () => !this.$swal.isLoading()
        })
      })
    },
    deleteItem (item, index) {
      const path = '/image-gallery/' + item.id
      const params = {
        current_user: this.currentUser
      }
      const auth = {username: this.authUsername, password: this.authPassword}
      Api.delete(path, params, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.getAboutData(this.activeProjectID, this.activeDetailsID)
            this.$swal(response.data.message)
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 10px;
}
#about-page {
  font-family: 'Lato', sans-serif;
  font-size: 1.2vmax;
}
#slogan {
  font-size: 2vmax;
  font-family: 'Vollkorn', serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
.page-subheading {
  font-size: 2vmax;
}
</style>


// WEBPACK FOOTER //
// src/admin_pages/ImageGalleryMenuItem.vue